import React from 'react';
import '../CRM.css';

const STATUS_MAP = {
  New: 'crm-badge-new',
  Contacted: 'crm-badge-contacted',
  Interested: 'crm-badge-interested',
  'Not Interested': 'crm-badge-not-interested',
  Qualified: 'crm-badge-qualified',
  Requirement: 'crm-badge-requirement',
  Quotation: 'crm-badge-quotation',
  Negotiation: 'crm-badge-negotiation',
  Won: 'crm-badge-won',
  Lost: 'crm-badge-lost',
  Converted: 'crm-badge-converted',
  Pending: 'crm-badge-pending',
  Completed: 'crm-badge-completed',
  Rescheduled: 'crm-badge-rescheduled',
  Cancelled: 'crm-badge-cancelled',
  Overdue: 'crm-badge-overdue',
  IndiaMART: 'crm-badge-indiamart',
  High: 'crm-badge-high',
  Medium: 'crm-badge-medium',
  Low: 'crm-badge-low',
};

export const LeadStatusBadge = ({ status, labelOverride }) => {
  if (!status && !labelOverride) return null;
  return <span className={`crm-badge ${STATUS_MAP[status] || 'crm-badge-new'}`}>{labelOverride || status}</span>;
};

export const PriorityBadge = ({ priority }) => {
  if (!priority) return null;
  return <span className={`crm-badge ${STATUS_MAP[priority] || 'crm-badge-medium'}`}>{priority}</span>;
};

export const SourceBadge = ({ source }) => {
  if (!source) return null;
  if (source === 'IndiaMART') return <span className="crm-badge crm-badge-indiamart">IndiaMART</span>;
  return <span className="crm-badge crm-badge-contacted">{source}</span>;
};

export default LeadStatusBadge;
